import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { filter } from 'rxjs/operators';
import { keyboard$ } from '../keyboard';

export const BarcodeReader = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['eventFilterIdentifier'],
    created() {
        this.subscribeTo(keyboard$.pipe(
            filter(
                inputEvent => !this.eventFilterIdentifier ||
                    (inputEvent.inputEventIdentifier === this.eventFilterIdentifier)
            )
        ), input => {
            this.$emit('input', input.char);
        });
    },
    render() {
        return null;
    },
})
